export const getSpotTitle = (type) => {
  let result = "";
  if (type) {
    const splitString = type.split("_");
    result = splitString.reduce((acc, itm) => {
      acc += itm.substring(0, 1).toUpperCase() + itm.substring(1).toLowerCase();
      acc += " ";
      return acc;
    }, "");
    return result;
  }
};

export const COUNTRY_CODE = {
  "+1": "USA",
  "+52": "MEX",
};

export const DEFAULT_COUNTRY_CODE = "+1";

export const DEFAULT_COUNTRY = "USA";
